import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import styled from 'styled-components';

//UI
import { SampleNextArrowUi, SamplePrevArrowUi } from 'modules/global/SampleArrows';

export const SliderUI = styled(Slider)`
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  .slick-slide {
    padding-left: 20px;
    padding-right: 20px;
    @media screen and (max-width: 1300px) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  ${SampleNextArrowUi} {
    @media screen and (min-width: 1300px) {
      & > {
        right: -20px;
      }
    }
    ${whiteTheme.media.mobileXS} {
      right: 0px;
    }
  }

  ${SamplePrevArrowUi} {
    @media screen and (min-width: 1300px) {
      & > {
        left: -20px;
      }
    }
    ${whiteTheme.media.mobileXS} {
      left: 0px;
    }
  }

  ${whiteTheme.media.laptopS} {
    max-width: 400px;
  }
  ${whiteTheme.media.tabletS} {
    max-width: 212px;
  }
  ${whiteTheme.media.tablet} {
    max-width: 780px;
  }
  ${whiteTheme.media.mobileL} {
    max-width: 100%;
    width: calc(100% - 230px);
  }
  ${whiteTheme.media.mobileS} {
    max-width: 100%;
    width: calc(100% - 180px);
  }
  ${whiteTheme.media.mobileM} {
    max-width: 100%;
    width: calc(100% - 130px);
  }
  ${whiteTheme.media.mobileXS} {
    width: calc(100% - 20px);
  }
`;

export const Wrap = styled.div`
  display: flex;
  max-width: 700px;
  width: 100%;
  position: relative;
  margin-bottom: 105px;
  ${whiteTheme.media.mobileL} {
    margin-bottom: 50px;
  }
  ${whiteTheme.media.mobileM} {
    margin-bottom: 40px;
  }
`;
